<a class="button not-underline" title="{{isDisabled() && showTitle ? 'Vyplňte prosím povinné údaje' : ''}}" [ngClass]="{disabled: isDisabled()}" (click)="doAction($event);">
    <span class="button-loading small-spinner" [loading]="processing">
        <ng-content></ng-content>
    </span>
</a>
